export default __webpack_public_path__ + "static/media/67.c2cb4ef5.jpg";